

import { polygon } from 'viem/chains';
import { polygonIconUrl } from '../../../../../../../constants/Data';

export const createTokensList = (
  userTokens,
  nativeCurrency
) => {

  if (!nativeCurrency || !userTokens.length) return [];

  return [
    {
      address: "0x0",
      decimals: nativeCurrency?.decimals || 0,
      iconUrl: polygonIconUrl,
      symbol: nativeCurrency?.symbol || "",
      value: nativeCurrency?.formatted || "",
      isNanite: true,
    },
    ...userTokens
      .filter(
        token =>
          token.symbol.toLowerCase() === "usdt" ||
          token.symbol.toLowerCase() === "usdc"
      )
      .map(token => ({
        value: token?.valueInUsdt ? token.valueInUsdt.toString() : "0",
        symbol: token.symbol,
        iconUrl: token.iconUrl,
        address: token.address,
        decimals: token.decimals,
        isNanite: false,
      })),
  ];
};
